import { createSlice } from "@reduxjs/toolkit";

const emarSlice = createSlice({
    name: "emar",
    initialState: {
        selectedPatient: {},
        filters : {}
    },
    reducers: {
        updateSelectedPatient: (state, action) => {
            state.selectedPatient = action.payload;
        },
        clearSelectedPatient: (state, action) => {
            state.selectedPatient = {};
        },
        updateFilters: (state, action) => {
            state.filters = action.payload;
        },
        clearFilters: (state, action) => {
            state.filters = {};
        },
    },
});
export const selectPatient = (state) => {
    return state?.emar;
};
export const { updateSelectedPatient, clearSelectedPatient, updateFilters, clearFilters } =
    emarSlice.actions;

export default emarSlice.reducer;
